/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const base = require('storepickup-base/checkout/shipping');
const addressHelpers = require('./address');
const extendState = require('../components/extendStates');
const formHelpers = require('../components/form');
const formHelpersError = require('./formErrors');
const SummaryHelpers = require('./summary');
const scrollAnimate = require('../components/scrollAnimate');

// verify every input for some related form
const verifyForm = (form) => {
    $(document).on('keyup', `${form} input[required]`, (event) => {
        const $input = $(event.currentTarget);

        if ($input.attr('pattern') !== '' || $input.attr('pattern') === undefined) {
            const regex = new RegExp($input.attr('pattern'));
            const isRegexCorrect = regex.test($input.val());

            // verify if the input regex is correct and the content is not void
            if (!isRegexCorrect || $input.val() === '') {
                const errorText = $input.attr('missing-error');

                $input.parent().find('.invalid-feedback').text(errorText);
                $input.addClass('is-invalid');
            } else {
                $input.parent().find('.invalid-feedback').text('');
                $input.removeClass('is-invalid');
            }
        }
    });
};

/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
    $(`[data-shipment-summary=${shipping.UUID}]`).each((i, el) => {
        const $container = $(el);
        const $shippingAddressLabel = $container.find('.shipping-addr-label');
        const $addressContainer = $container.find('.address-summary');
        const $shippingPhone = $container.find('.shipping-phone');
        const $methodTitle = $container.find('.shipping-method-title');
        const $methodArrivalTime = $container.find('.shipping-method-arrival-time');
        const $methodPrice = $container.find('.shipping-method-price');
        const $shippingSummaryLabel = $container.find('.shipping-method-label');
        const $summaryDetails = $container.find('.row.summary-details');
        const giftMessageSummary = $container.find('.gift-summary');

        const address = shipping.shippingAddress;
        const { selectedShippingMethod } = shipping;
        const { isGift } = shipping;

        addressHelpers.methods.populateAddressSummary($addressContainer, address);

        if (address && address.phone) {
            $shippingPhone.text(address.phone);
        } else {
            $shippingPhone.empty();
        }

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                {
                    selectedShippingMethod: selectedShippingMethod,
                    resources: order.resources,
                    shippingAddressLabel: $shippingAddressLabel,
                });
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            $methodTitle.text(selectedShippingMethod.displayName);
            if (selectedShippingMethod.description && selectedShippingMethod.description.length > 0) {
                $methodTitle.append(`<br/><span>${selectedShippingMethod.description}</span>`);
            }

            if (selectedShippingMethod.estimatedArrivalTime) {
                $methodArrivalTime.text(`( ${selectedShippingMethod.estimatedArrivalTime} )`);
            } else {
                $methodArrivalTime.empty();
            }
            $methodPrice.text(selectedShippingMethod.shippingCost);

            if (order && order.productErrors) {
                let productMessage = $('.summary-details .shipping-method-exclusion-products').attr('data-info-message');
                if (productMessage) {
                    $('.summary-details .shipping-method-exclusion-products').html('<b>'+productMessage+'</b>');
                }
            } else {
              $('.summary-details .shipping-method-exclusion-products').html('');
            }
        }

        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }
    });

    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });

    setTimeout(() => {
        SummaryHelpers.updateTotals(order.totals);
    }, 500);
}


/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
    const uuidEl = $(`input[value=${shipping.UUID}]`);
    if (uuidEl && uuidEl.length > 0) {
        $.each(uuidEl, (shipmentIndex, el) => {
            const { form } = el;
            if (!form) return;

            const $shippingMethodList = $('.shipping-method-list', form);

            if ($shippingMethodList && $shippingMethodList.length > 0) {
                const wasFocusInList = $.contains($shippingMethodList[0], document.activeElement);
                $shippingMethodList.empty();
                const shippingMethods = shipping.applicableShippingMethods;
                const selected = shipping.selectedShippingMethod || {};
                const shippingMethodFormID = `${form.name}_shippingAddress_shippingMethodID`;
                //
                // Create the new rows for each shipping method
                //
                $.each(shippingMethods, (methodIndex, shippingMethod) => {
                    if (!shippingMethod.noDisplay && shippingMethod.displayName && shippingMethod.displayName !== 'null') {
                        const tmpl = $('#shipping-method-template').clone();
                        tmpl.attr('mcclane-data', `checkout-shipping-method-[${shippingMethod.ID}]`);
                        // set input
                        $('input', tmpl)
                            .prop('id', `shippingMethod-${shippingMethod.ID}`)
                            .prop('name', shippingMethodFormID)
                            .prop('value', shippingMethod.ID)
                            .attr('checked', shippingMethod.ID === selected.ID)
                            .attr('data-pickup', shippingMethod.storePickupEnabled)
                            .attr('data-clickcollect', shippingMethod.clickCollect)
                            .attr('data-deliverypoint', shippingMethod.deliveryPoint)
                            .attr('data-deliverypointurl', shippingMethod.deliveryPointUrl);

                        $('label', tmpl).prop('for', `shippingMethod-${shippingMethod.ID}`);
                        // set shipping method name
                        $('.display-name', tmpl).text(shippingMethod.displayName);
                        // set or hide arrival time
                        if (shippingMethod.estimatedArrivalTime) {
                            $('.arrival-time', tmpl)
                                .text(`(${shippingMethod.estimatedArrivalTime})`)
                                .show();
                        }
                        // set description
                        if (shippingMethod.description) {
                            $('.shippingDescription', tmpl).text(`${shippingMethod.description}`).show();
                        }

                        // set shipping cost
                        const shippingCost = $('.shipping-cost', tmpl);
                        const shippingCostData = $('.shipping-methods-list-wrapper').attr('data-shipping-free');
                        if (parseInt(shippingMethod.shippingCost, 10) <= 0) {
                            shippingCost.text(shippingCostData);
                        } else {
                            shippingCost.text(shippingMethod.shippingCost);
                        }
                        shippingCost.attr('data-shipping-cost', shippingMethod.shippingCost);
                        $shippingMethodList.append(tmpl.html());
                    }
                });
                if (wasFocusInList) {
                    $('input.form-check-input:checked', $shippingMethodList).trigger('focus');
                }
            }
        });
    }

    $('body').trigger('shipping:updateShippingMethods', { shipping });
    formHelpers.inputFocus();
}


/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach((aShipping) => {
        aShipping.productLineItems.items.forEach((productLineItem) => {
            base.methods.updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });

    // Now update shipping information, based on those associations
    updateShippingMethods(shipping);
    base.methods.updateShippingAddressFormValues(shipping);
    updateShippingSummaryInformation(shipping, order);

    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach((productLineItem) => {
        base.methods.updateShippingAddressSelector(productLineItem, shipping, order, customer);
        base.methods.updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });
}

function updateShippingListByCountry(form) {
    setTimeout(() => {
        const $shippingMethodList = $(form).find('.shipping-method-list');
        const urlParams = addressHelpers.methods.getAddressFieldsFromUI(form);
        const url = $shippingMethodList.data('actionUrl');
        urlParams.shipmentUUID = $('input[name=shipmentUUID]', form).val();

        if (!urlParams.countryCode) {
            urlParams.countryCode = $('#countryCodeGeo').val();
        }

        $shippingMethodList.spinner().start();
        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success(data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView', {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true },
                    });
                    formHelpers.inputFocus();
                    $shippingMethodList.spinner().stop();
                }
            },
        });
    }, 300);
}

const selectSingleShipAddressLogic = (e, stateMethods) => {
    const target = $(e.currentTarget);
    const forms = $('.shipping-form');
    const selectedOption = $('option:selected', target);
    const attrs = selectedOption.data();
    const shipmentUUID = selectedOption[0].value;
    const originalUUID = $('input[name=shipmentUUID]', forms[0]).val();
    let element;
    forms.each((form) => {
        Object.keys(attrs).forEach((attr) => {
            element = attr === 'countryCode' ? 'country' : attr;
            $(`[name$=${element}]`, form).val(attrs[attr]);
        });
    });

    $('[id^="shippingState-"]').each((index, node) => {
        $(node).html('');
    });

    if (attrs.countryCode) {
        $('[id^="shippingCountry-"]').each((index, node) => {
            const identShipping = $(node).attr('id');
            const idenState = identShipping.replace('shippingCountry-', '');
            const identZip = `#shippingZipCode-${idenState}`;
            const identPhone = `#shippingPhoneNumber-${idenState}`;
            stateMethods.updateStates(
                attrs.countryCode,
                `#${identShipping}`,
                `#shippingState-${idenState}`,
                'shipping',
                attrs.stateCode,
                $(identZip).val(),
                $(identPhone).val(),
            );
        });
    }

    forms.each((index, form) => {
        updateShippingListByCountry(form);
        if (index === 0) {
            if (shipmentUUID === 'new') {
                $(form).attr('data-address-mode', 'new');
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'customer');
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
        }
    });
};

function updateCountryDropdown() {
    const shippingCountryDropdown = $('#shippingCountry');

    if (shippingCountryDropdown.find('option').length <= 2) {
        shippingCountryDropdown.find('option:eq(0)').removeAttr('selected');
        shippingCountryDropdown.val(shippingCountryDropdown.find('option:eq(1)').val());
    }
}

// this must be executed like this: selectSingleShipAddress(extendState)
// in onestic-base is not executed for provide the declared function and
// be executed in the project cartridge
const selectSingleShipAddress = () => {
    const stateMethods = extendState;
    // eslint-disable-next-line func-names
    $('.single-shipping .addressSelector').on('change', (e) => {
        selectSingleShipAddressLogic(e, stateMethods);
        updateCountryDropdown();
    });
};

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse(defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip ? '.multi-shipping .active form' : '.single-shipping form';

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpersError.loadFormErrors(formSelector, error);
                }
            });
            defer.reject(data);
        }

        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                base.methods.createErrorNotification(element);
            });

            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        // Populate the Address Summary
        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        scrollAnimate($('.payment-form'));
        defer.resolve(data);
    }
}

module.exports = {
    methods: {
        updateShippingAddressSelector: base.updateShippingAddressSelector,
        updateShippingAddressFormValues: base.methods.updateShippingAddressFormValues,
        updateShippingMethods: updateShippingMethods,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: base.methods.updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: base.methods.updateProductLineItemShipmentUUIDs,
        updateShippingInformation,
        updateMultiShipInformation: base.methods.updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        createNewShipment: base.methods.createNewShipment,
        selectShippingMethodAjax: base.methods.selectShippingMethodAjax,
        updateShippingMethodList: base.methods.updateShippingMethodList,
        clearShippingForms: base.methods.clearShippingForms,
        editMultiShipAddress: base.methods.editMultiShipAddress,
        editOrEnterMultiShipInfo: base.methods.editOrEnterMultiShipInfo,
        createErrorNotification: base.methods.createErrorNotification,
        viewMultishipAddress: base.methods.viewMultishipAddress,
        selectSingleShipAddressLogic,
    },
    selectShippingMethod: base.selectShippingMethod,
    toggleMultiship: base.toggleMultiship,
    selectSingleShipAddress,
    selectSingleShipping: base.selectSingleShipping,
    selectMultiShipAddress: base.selectMultiShipAddress,
    selectMultiShipping: base.selectMultiShipping,
    updateShippingListUsingCountry(form) {
        if (form) {
            updateShippingListByCountry(form);
        }
    },
    updateShippingList: base.updateShippingList,
    updateDataAddressMode: base.updateDataAddressMode,
    enterMultiShipInfo: base.enterMultiShipInfo,
    editMultiShipInfo: base.editMultiShipInfo,
    saveMultiShipInfo: base.saveMultiShipInfo,
    cancelMultiShipAddress: base.cancelMultiShipAddress,
    isGift: () => {
        $('.gift:not(.disabled)').on('change', (e) => {
            e.preventDefault();
            const thisTarget = $(e.currentTarget);
            const form = thisTarget.closest('form');

            if (thisTarget.is(':checked')) {
                $(form).find('.gift-message').removeClass('d-none');
            } else {
                $(form).find('.gift-message').addClass('d-none');
                $(form).find('.gift-message').val('');
            }
        });
    },
    verifyShippinggForm() {
        verifyForm('.shipping-address-block');
    },
};
